/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type DivorceProps = {
  basePath: string;
  product: AbstractCase;
};
const Divorce = ({ basePath, product }: DivorceProps) => {
  const formPath = basePath + "/ehe-und-scheidung";
  const section = "divorce";
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Ehe und Scheidung</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"dateMarriage"} fieldType={"date"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"cityMarriage"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"numberChildren"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"statusDivorce"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"dateSeparation"} fieldType={"date"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"movedOut"} formUrl={formPath} anchorId={section} />
      {product.movedOut !== "nobody" && (
        <SummaryDetailsItem caseData={product} fieldPath={"dateMovedOut"} fieldType={"date"} formUrl={formPath} anchorId={section} />
      )}
    </>
  );
};

export default Divorce;
